import { Service } from "../../../glue/Kernel.js";
import { Client } from "./net.js";

// The client's connection to a world: the WebSocket, the snapshot state it carries, and
// the input it sends back — all held in the Client this wraps. The Client needs nothing
// from siblings, and main.js reads it synchronously right after building the Kernel, so
// it's created in the constructor (unlike the server's WorldsService, which waits for
// init to read the seed off config).
//
// connect() bridges the Client's callbacks onto the service event bus as `net.*` events,
// so any service (render, audio, ui, …) can subscribe to the connection independently
// instead of main.js holding the only set of hooks. The Client updates its own state
// before each callback, so a listener always sees consistent data.
export class NetService extends Service {
    constructor() {
        super();
        this.client = new Client();
    }

    connect(name, color, server) {
        this.client.connect(name, color, server, {
            onConnecting: () => this.emit("net.connecting"),
            onWelcome: (m) => this.emit("net.welcome", m),
            onState: (m) => this.emit("net.state", m),
            onChat: (m) => this.emit("net.chat", m),
            onMusic: (m) => this.emit("net.music", m),
            onNotice: (m) => this.emit("net.notice", m),
            onJoinFail: (m) => this.emit("net.joinfail", m),
            onClose: () => this.emit("net.close"),
            onError: (msg) => this.emit("net.error", msg),
        });
    }
}
